<script setup lang="ts">
import { computed } from "vue";

import PureSlide from "@components/PureSlide.vue";
import type { PureSlideProps } from "@components/PureSlide.vue";

const props = defineProps<{
  actionId: string;
  startsAt: string;
  description: string;
  screenshotUrl?: string;
  slide?: PureSlideProps;
  inThePast: boolean;
  isCurrent: boolean;
  alignHover: "left" | "center" | "right";
}>();

const emit = defineEmits<{
  (e: "click"): void;
}>();

const inTheFuture = computed(() => !props.inThePast);
</script>

<template>
  <button
    class="group/item relative flex h-7 cursor-pointer items-center px-px outline-none"
    :aria-label="description"
    :aria-describedby="actionId"
    :data-starts-at="startsAt"
    @click.stop="emit('click')"
  >
    <div
      class="w-full rounded-sm drop-shadow-sm transition-all"
      :class="[
        isCurrent
          ? 'h-1 sm:h-2'
          : 'h-0.5 group-hover/item:h-1.5 group-focus-visible/item:h-1.5 sm:h-1 group-hover/item:sm:h-2.5 group-focus-visible/item:sm:h-2.5',
        !isCurrent && inTheFuture
          ? 'bg-white/40 group-hover/item:bg-white/90 group-focus-visible/item:bg-white/90'
          : 'bg-white/90',
      ]"
    ></div>

    <!-- show time on hover: -->
    <div
      class="absolute -top-2 left-0 text-xs text-white opacity-0 drop-shadow transition-all group-hover/item:opacity-100 group-focus-visible/item:opacity-100"
    >
      {{ startsAt }}
    </div>

    <!-- show thumbnail on hover: -->
    <div
      v-if="screenshotUrl || slide"
      :id="actionId"
      class="pointer-events-none absolute bottom-10 z-50 my-auto hidden aspect-video w-80 items-center justify-center overflow-hidden rounded-md bg-neutral-300 text-left text-neutral-500 shadow-lg ring-1 ring-black/10 group-hover/item:flex group-focus-visible/item:flex"
      :class="{
        'right-0': alignHover === 'right',
        'left-1/2 -translate-x-1/2': alignHover === 'center',
        'left-0': alignHover === 'left',
      }"
      role="tooltip"
    >
      <img v-if="screenshotUrl" :src="screenshotUrl" alt="" loading="lazy" decoding="async" />
      <PureSlide
        v-else-if="slide"
        v-bind="{ ...slide, disablePointerEvents: true }"
        class="grow bg-white/30"
      />
    </div>
  </button>
</template>
